import { ElementDefinition } from '@/runtime/shared/elements-definition';
import fontHtml from './stories/font.story.html?raw';
import sizeHtml from './stories/size.story.html?raw';

import { iconPropsDocs } from './icon.types';

/**
 * Docs definition for the Icon component and its custom elements.
 *
 * Used by the docs site to render:
 * - API tables for `<e-icon>`
 * - Example stories in the code playground
 */
export const definition: ElementDefinition = {
  componentName: 'Icon',
  description: 'An icon component to display vector icons.',
  elements: [
    {
      tag: 'e-icon',
      description: 'An icon component to display vector icons.',
      props: Object.values(iconPropsDocs),
      styling: [
        {
          name: '--e-icon-size',
          kind: 'css-variable',
          description: 'Controls the size of the icon.'
        }
      ]
    }
  ],

  stories: [
    {
      id: 'font',
      name: 'Font',
      description: 'An icon where the size is based on the parent font-size',
      html: fontHtml
    },
    {
      id: 'size',
      name: 'Size',
      description: 'An icon where the size is based on the `size` prop',
      html: sizeHtml
    }
  ]
};
